import { css, html, LitElement } from "lit"
import "./Ami.js"
import "./ListePokemons.js"

export default class ListeAmis extends LitElement {
  static properties = { listeAmis: { type: Array }, estModeAmis: { type: Boolean } }

  static styles = css`
    .liste-amis {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        background-color: var(--couleur-fond);
        border-radius: 1rem;
    }
    `

  constructor() {
    super()
    this.listeAmis = []
    this.estModeAmis = true
  }

  render() {
    return html`
        <div class="liste-amis">
            ${this.listeAmis.map((ami) => this.genererAmis(ami))}
        </div>`
  }

  genererAmis({ membre = "", id = "", echanges = [], commentaire = "" }) {
    return html`<div class="ami">
            <p-ami .nom=${membre} .id=${id} .echanges=${echanges} .commentaire=${commentaire} .estModeAmis=${this.estModeAmis}></p-ami>
        </div>`
  }
}
customElements.define("p-liste-amis", ListeAmis)
